// import components
import ControlledDatePicker from 'components/shared/ControlledFields/ControlledDatePicker';
import { GridContainer, GridCompact6 } from '../Grid/Grid.components';

// import hooks
import { useTranslation } from 'react-i18next';

// import types
import { ControlledValidFromValidToProps } from './ControlledValidFromValidTo.types';

export default function ControlledValidFromValidTo({
  control,
  disabledValidFrom,
  disabledValidTo,
  variant = 'outlined',
  validFromRequired = false,
  validToRequired = false,
  validFromFieldName = 'valid.from',
  validToFieldName = 'valid.to',
  showTodayButton = true
}: ControlledValidFromValidToProps) {
  const { t } = useTranslation('common');

  return (
    <GridContainer>
      <GridCompact6>
        <ControlledDatePicker
          fullWidth
          variant={variant}
          name={validFromFieldName}
          control={control}
          label={t('validFrom')}
          disabled={disabledValidFrom}
          required={validFromRequired}
          showTodayButton={showTodayButton}
        />
      </GridCompact6>
      <GridCompact6>
        <ControlledDatePicker
          fullWidth
          variant={variant}
          name={validToFieldName}
          control={control}
          label={t('validTo')}
          disabled={disabledValidTo}
          required={validToRequired}
          showTodayButton={showTodayButton}
        />
      </GridCompact6>
    </GridContainer>
  );
}
